import Event from '../../core/Event';
import { Products } from '../State';

export default class EstimationProductsReceived extends Event {
    public static type = 'EstimationProductsReceived';

    constructor(public readonly products: Products) {
        super(EstimationProductsReceived.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/products/events/EstimationProductsReceived.ts